import { useRef, useState } from 'react'

import useBreakPoints from './useBreakPoints'

type useCarouselReturn = {
  carouselRef: React.MutableRefObject<any>
  currentSlideIndex: number
  slidesNumber: number
  goToNextSlide: () => void
  goToPreviousSlide: () => void
  handleCurrentSlideIndex: (current: number) => void
}

const useCarousel = (length: number, overrideDisplayItems?: number): useCarouselReturn => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
  const carouselRef = useRef(null)

  const totalNumberOfAds = length
  const slidesCarouselNumber = overrideDisplayItems ?? (totalNumberOfAds < 3 ? totalNumberOfAds : 3)
  const { isMd } = useBreakPoints()

  const slidesNumber = isMd ? slidesCarouselNumber : 1

  const goToNextSlide = () => {
    carouselRef.current.next()
  }

  const goToPreviousSlide = () => {
    carouselRef.current.prev()
  }

  const handleCurrentSlideIndex = (current: number) => {
    setCurrentSlideIndex(Math.ceil(current))
  }

  return { carouselRef, currentSlideIndex, slidesNumber, goToNextSlide, goToPreviousSlide, handleCurrentSlideIndex }
}

export default useCarousel
